import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { motion } from 'framer-motion';

const navItems = [
  { path: '/', label: '首页', icon: '🏠' },
  { path: '/levels', label: '关卡', icon: '🎮' },
  { path: '/leaderboard', label: '排行榜', icon: '🏆' },
];

export default function Layout() {
  const location = useLocation();
  const { user, isAuthenticated } = useAuthStore();

  return (
    <div className="min-h-screen min-h-[100dvh] flex flex-col pb-safe">
      {/* Header */}
      <header className="glass-card mx-2 sm:mx-4 mt-2 sm:mt-4 px-3 sm:px-6 py-3 sm:py-4">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 sm:gap-3">
            <img 
              src="/sudoku.svg" 
              alt="疯狂的数独" 
              className="w-8 h-8 sm:w-10 sm:h-10"
            />
            <span className="text-lg sm:text-xl font-semibold hidden sm:block">疯狂的数独</span>
          </Link>

          <nav className="flex items-center gap-1 sm:gap-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-2 sm:px-4 py-2 rounded-lg transition-all text-sm sm:text-base ${
                  location.pathname === item.path
                    ? 'bg-green-500/20 text-green-600'
                    : 'hover:bg-white/10 text-gray-600'
                }`}
              >
                <span className="sm:mr-2">{item.icon}</span>
                <span className="hidden sm:inline">{item.label}</span>
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-4">
            {isAuthenticated ? (
              <Link
                to="/profile"
                className="flex items-center gap-2 px-2 sm:px-3 py-2 rounded-lg hover:bg-white/10 transition-all"
              >
                {user?.avatar ? (
                  <img
                    src={user.avatar}
                    alt={user.username}
                    className="w-7 h-7 sm:w-8 sm:h-8 rounded-full"
                  />
                ) : (
                  <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center text-xs sm:text-sm font-semibold text-white">
                    {user?.username?.[0]?.toUpperCase() || '?'}
                  </div>
                )}
                <span className="hidden md:block text-sm">{user?.username}</span>
              </Link>
            ) : (
              <Link to="/login" className="btn-primary text-xs sm:text-sm px-3 sm:px-6 py-2 sm:py-3">
                登录
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 p-2 sm:p-4">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.2 }}
          className="max-w-6xl mx-auto"
        >
          <Outlet />
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="text-center py-4 sm:py-6 text-xs sm:text-sm text-gray-500">
        <p>疯狂的数独 © {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}

